<template>
  <HeaderModule
    title="Themes Manager"
    icon="card-multiple-outline"
    description="Manage the themes and indicators used in the Map and Dashboards"
    :defaultTab="defaultTab"
    :key="headerModuleReloadKey"
    v-model:tabs="tabs"
    @scrollTabEvent="handleTabContentScroll"
    @headerTabTransitionEnd="activeTabTransitionComplete"
  >
    <template #manage>
      <ThemesManagerManage ref="manage" @addIndicator="addIndicator" />
    </template>

    <template #search>
      <ThemesManagerSearch
        ref="search"
        @reloadThemesManager="reloadThemesManager"
      />
    </template>
  </HeaderModule>
</template>
<script>
import HeaderModule from "@/components/HeaderModule.vue";
import ThemesManagerManage from "@/components/ThemesManagerManage.vue";
import ThemesManagerSearch from "@/components/ThemesManagerSearch.vue";

export default {
  name: "ThemesManager",
  components: { HeaderModule, ThemesManagerManage, ThemesManagerSearch },
  data: () => ({
    tabs: [
      { title: "Manage Themes", value: "manage", route: "manage" },
      {
        title: "Search Indicators",
        value: "search",
        route: "search",
        chip: null,
        loading: true,
      },
    ],
    defaultTab: "manage",
    headerModuleReloadKey: 0,
  }),
  computed: {
    selectedThemeName: {
      get() {
        // Get the selected theme name from the Vuex store
        return this.$store.getters["themesManager/selectedThemeName"];
      },
      set(val) {
        // Update the selected theme name in the Vuex store
        this.$store.commit("themesManager/setSelectedThemeName", val);
      },
    },
    selectedThemeId: {
      get() {
        return this.$store.getters["themesManager/selectedThemeId"];
      },
      set(val) {
        this.$store.commit("themesManager/setSelectedThemeId", val);
      },
    },
  },
  mounted() {
    this.getSearchableIndicatorCount();
  },
  methods: {
    getSearchableIndicatorCount() {
      this.$axios
        .get("/get-searchable-indicators-count")
        .then((response) => {
          this.updateTab(response.data.count);
        })
        .catch((error) => {
          console.error(error);
          this.$emit("systemMessage", {
            title: "Error! Failed to get searchable indicators count",
            message: "Error! Failed to get searchable indicators count",
            timeout: -1,
            colour: "error",
          });
        });
    },
    // Update the count of searchable indicators in the search tab
    updateTab(count) {
      const searchTab = this.tabs.find((tab) => tab.value === "search");
      if (searchTab) {
        searchTab.chip = count;
        searchTab.loading = false;
      }
    },
    // handle lazy loading when scrolling through catalogue
    handleTabContentScroll(tab) {
      if (tab === "search") {
        this.$refs.search.getPaginatedIndicators();
      }
    },
    reloadThemesManager() {
      const themes = this.$refs.manage?.themes;

      if (themes?.length) {
        this.$refs.manage.fetchThemes();
      }
      if (this.selectedThemeId) {
        this.$refs.manage.fetchindicators(this.selectedThemeId);
      }
    },
    /** set selectedThemeId when addIndicator event occurs (passed as prop to ThemesManagerSearch) */
    addIndicator() {
      if (this.$refs.search != undefined) {
        this.$refs.search.setSingleThemeindicatorButtonState();
      }
    },
    /** actions when header tab transition event completes */
    activeTabTransitionComplete(tab) {
      //changed to the manage tab
      if (tab == "manage") {
        // Select first theme if no theme is selected
        if (!this.selectedThemeId) {
          const firstTheme = this.$refs.manage?.themes[0];
          if (firstTheme) {
            this.selectedThemeId = firstTheme.id;
            this.selectedThemeName = firstTheme.name;
          }
        }
      }
    },
  },
};
</script>
